export const PriceTypes = {
  PRICE_NORMAL: 'normal',
  PRICE_COUPON: 'coupon',
  PRICE_ABO: 'abo',
}
